import React, { useState } from 'react';
import { notifySuccess, notifyWarning } from '../utils/notify';

const StoreMaster = ({ stores, onAddStore }) => {
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    address: ''
  });

  const handleSubmit = () => {
    if (!formData.code || !formData.name) {
      notifyWarning('Please fill all required fields');
      return;
    }
    if (stores.find(s => s.code === formData.code)) {
      notifyWarning('Retail Code already exists!');
      return;
    }
    onAddStore(formData);
    notifySuccess('Store added successfully.');
    setFormData({ code: '', name: '', address: '' });
  };

  return (
    <section>
      <div className="bg-white p-4 md:p-6 rounded-lg shadow-sm border border-gray-200">
        <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">Retail Store Master</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-6 md:mb-8">
          <div>
            <label className="block text-xs md:text-sm font-bold mb-1">Retail Code</label>
            <input 
              type="text" 
              value={formData.code}
              onChange={(e) => setFormData({...formData, code: e.target.value})}
              className="w-full p-2 border rounded text-sm md:text-base" 
              placeholder="Ex: S004"
            />
          </div>
          <div>
            <label className="block text-xs md:text-sm font-bold mb-1">Retail Name</label>
            <input 
              type="text" 
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full p-2 border rounded text-sm md:text-base" 
              placeholder="Ex: Store Chennai"
            />
          </div>
          <div>
            <label className="block text-xs md:text-sm font-bold mb-1">Address</label>
            <input 
              type="text" 
              value={formData.address}
              onChange={(e) => setFormData({...formData, address: e.target.value})}
              className="w-full p-2 border rounded text-sm md:text-base" 
              placeholder="Full Address"
            />
          </div>
          <div className="flex items-end">
            <button 
              onClick={handleSubmit}
              className="w-full bg-green-600 text-white px-4 md:px-6 py-2 rounded font-bold hover:bg-green-700 transition text-sm md:text-base"
            >
              ADD STORE
            </button>
          </div>
        </div>
        <div className="overflow-x-auto -mx-4 md:mx-0">
          <table className="w-full text-left border-collapse min-w-[600px]">
            <thead>
              <tr className="bg-gray-100">
                <th className="p-2 md:p-3 border text-xs md:text-sm">Code</th>
                <th className="p-2 md:p-3 border text-xs md:text-sm">Name</th>
                <th className="p-2 md:p-3 border text-xs md:text-sm">Address</th>
              </tr>
            </thead>
            <tbody>
              {stores.map(store => (
                <tr key={store.code}>
                  <td className="p-2 border text-xs md:text-sm">{store.code}</td>
                  <td className="p-2 border text-xs md:text-sm">{store.name}</td>
                  <td className="p-2 border text-xs md:text-sm">{store.address}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default StoreMaster;
